/**
 * Speculation Rules - Prerender same-origin URLs on link hover.
 * One delegated listener replaces a listener on every anchor.
 */
document.addEventListener('DOMContentLoaded', function () {
  var speculationRules = document.getElementById('speculationrules');
  if (!speculationRules) return;

  var links = document.querySelectorAll('a[href]');
  if (!links.length) return;

  var eligible = new WeakSet();
  for (var i = 0; i < links.length; i++) eligible.add(links[i]);

  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a');
    if (!link || !eligible.has(link) || !link.href) return;

    try {
      var parsed = new URL(link.href, window.location.href);
      if (parsed.origin !== window.location.origin) return;
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return;

      var rules = JSON.parse(speculationRules.textContent);
      var url = link.href;

      if (!rules.prerender[0].urls.includes(url)) {
        rules.prerender[0].urls.push(url);
        speculationRules.textContent = JSON.stringify(rules);
      }
    } catch (e) {
      // Silently fail if parsing fails
    }
  }, { passive: true });
});
